import { render, staticRenderFns } from "./AppUserAvatar.vue?vue&type=template&id=528caa79"
import script from "./AppUserAvatar.vue?vue&type=script&lang=js"
export * from "./AppUserAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports